<script setup lang="ts"></script>

<template>
  <icon name="lucide:log-out" />
</template>

<style scoped></style>
